import React from "react";
import {FormattedMessage} from "react-intl";
import Icon from "../Utils/Icon";
import classes from "./styles.module.css";

function Support({data}) {
    const openSupportWidget = (e) => {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('open-support-widget'));
    };

    return (
        <div className={classes.SupportWrap}>
            <div className={classes.SupportManagers}>
                <div>
                    <div className={classes.SupportTitle}>
                        <FormattedMessage id="Support.manager.title" defaultMessage="Ваш менеджер"/>
                    </div>
                    <ul className={classes.SupportList}>
                        <li>
                            <Icon className={classes.Icon} icon="user-tie" size="18px"/>
                            <span>{(data && data.display_name) || ""}</span>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="envelop" size="18px"/>
                            <a className={classes.SupportLink} href={`mailto:${(data && data.email) || ""}`}>
                                {(data && data.email) || ""}
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="phone1" size="18px"/>
                            <a className={classes.SupportLink}
                               href={`tel:${(data && data.phone && data.phone.replace(/[^\d;+]/g, "")) || ""}`}>
                                {(data && data.phone) || ""}
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="mobile" size="18px"/>
                            <a className={classes.SupportLink} href="tel:+79330922891">
                                +7 (933) 092-28-91
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className={classes.SupportTitle}>
                        <FormattedMessage id="Support.tech.title" defaultMessage="Технические вопросы"/>
                    </div>
                    <ul className={classes.SupportList}>
                        <li>
                            <Icon className={classes.Icon} icon="envelop" size="18px"/>
                            <a className={classes.SupportLink} href="mailto:support@unlimco.ru">
                                support@unlimco.ru
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="phone1" size="18px"/>
                            <a className={classes.SupportLink} href="tel:+79330922891">
                                +7 (933) 092-28-91
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="lifebuoy" size="18px"/>
                            <a className={classes.SupportLink} href="#" onClick={openSupportWidget}>
                                <FormattedMessage id="Support.chat.button" defaultMessage="Чат поддержки"/>
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="telegram" size="20px"/>
                            <a className={classes.SupportLink}
                               href="https://t.me/sup_fintech"
                               target="_blank"
                               rel="noopener noreferrer">
                                @sup_fintech
                            </a>
                        </li>
                    </ul>
                </div>

                <div>
                    <div className={classes.SupportTitle}>
                        <FormattedMessage id="Support.general.title" defaultMessage="Общие вопросы"/>
                    </div>
                    <ul className={classes.SupportList}>
                        <li>
                            <Icon className={classes.Icon} icon="phone1" size="18px"/>
                            <a className={classes.SupportLink} href="tel:+79330922891">
                                +7 (933) 092-28-91
                            </a>
                        </li>
                        <li>
                            <Icon className={classes.Icon} icon="lifebuoy" size="18px"/>
                            <a className={classes.SupportLink} href="#" onClick={openSupportWidget}>
                                <FormattedMessage id="Support.chat.button" defaultMessage="Чат поддержки"/>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className={classes.SupportTicket}>
                <div className={classes.TicketTitle}>
                    <FormattedMessage id="Support.ticket.title" defaultMessage="Нужна помощь?"/>
                </div>
                <a className={classes.Btn} href="#" onClick={openSupportWidget}>
                    <Icon className={classes.IconLeft} icon="add-outline" size="16px"/>
                    <FormattedMessage id="Support.ticket.create" defaultMessage="Оставить обращение"/>
                </a>
            </div>
        </div>
    );
}

export default Support;



// WEBPACK FOOTER //
// ./src/Components/HeaderMenu/Support.js